
import { Map } from 'immutable';
import actions from './../actions';
import appActions from '@synergycms_core/store/app/appActions';
import moment from 'moment';





export default {
  ...appActions,
  GO_TO_MONO_HOTEL_ASYNC : (hotelId) => {
    return (dispatch, getState) => {

      const {
        currentHotel: currentHotelAction,
        params: paramsAction,
        reservationRequest: reservationRequestAction,
        roomPreferences: roomPreferencesActions,
        ipCountry: ipCountryActions,
        loyalty:loyaltyActions
      } = actions.customer;

      const availActions = actions.avail;
      const availServicesActions = actions.availServices;
      const availCacheActions = actions.availCache;

      const store = getState();

      //ACTIVE LOYALTY
      dispatch(currentHotelAction.set(hotelId));
      dispatch(paramsAction.updateParams(Map({ hotelId: hotelId })));

      let availCacheParams = store.getIn(['customer', 'params', 'avail_cache_params'],Map());
      let availParams = store.getIn(['customer', 'params', 'params'], Map());

      const hotelsDescriptives = store.getIn(['hotels', hotelId]);
      availCacheParams = availCacheParams
        .set('city_id', hotelsDescriptives.get("city_id"))
        .set('hotelId', null);


      let props = {
        avail : dispatch(loyaltyActions.loyaltyAsync()).then(()=> dispatch(availActions.getAvailAsync())),
          services : dispatch(availServicesActions.getAsync()),
          loyalty : dispatch(loyaltyActions.loyaltyAsync()).then(()=> {
            dispatch(availActions.getAvailAsync()).then(()=>{
              dispatch(availActions.getAvailParsed())
            })
          }),
          availCache : dispatch(availCacheActions.getAsync(
            availParams.get("date"), 
            moment(availParams.get("date")).add(availParams.get("stay_length"),"days"), 
            {params:availCacheParams}
          ))
      }

    

      Promise.props(props).then(() => {
        dispatch(reservationRequestAction.initialize());
        dispatch(actions.customer.step.next());
        dispatch(roomPreferencesActions.initialize());
        dispatch(ipCountryActions.getAsync());
        dispatch(actions.router.update());
        dispatch(actions.customer.header.show('engine', false));
        const idHotelInput = document.getElementById('id_hotel');

        if (idHotelInput !== null && typeof window.showNotifications === 'function') {
          document.getElementById('id_hotel').value = hotelsDescriptives.code;
          window.showNotifications();
        }
      });
    };
  }
};
